import { Table, Typography } from "antd";
import React from "react";

const RotorTable = ({ rotorData }) => {
  // If no data or empty array, return null
  if (!rotorData || rotorData.length === 0) {
    return null;
  }

  // Extract headers from first array
  const headers = rotorData[0];

  // Extract rows data (skip the first array which contains headers)
  const rowsData = rotorData.slice(1);

  // Create columns configuration for Ant Design table
  const columns = headers.map((header, index) => ({
    title: header,
    dataIndex: `col_${index}`,
    key: `col_${index}`,
    align: "center",
    className: index === 0 ? "rotor-order-column" : "rotor-data-column",
  }));

  // Transform rows data into objects that Ant Design table can understand
  const dataSource = rowsData.map((row, rowIndex) => {
    const rowObject = { key: rowIndex };
    row.forEach((cell, cellIndex) => {
      rowObject[`col_${cellIndex}`] = cell;
    });
    return rowObject;
  });

  return (
    <div style={{ margin: "24px 0" }}>
      <Typography.Title
        level={3}
        className="rotor-table-title"
        style={{ marginBottom: "16px", textAlign: "center" }}
      >
        Additional Rotors
      </Typography.Title>
      <Table
        dataSource={dataSource}
        columns={columns}
        pagination={false}
        bordered
        style={{ borderRadius: "8px", overflow: "hidden" }}
        size="middle"
      />
    </div>
  );
};

export default RotorTable;
